"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFormDataFields = void 0;
exports.UploadFormDataFields = {
    TARGET_CONTAINER: 'targetContainer',
    FILE_NAMES: 'fileNames',
    FILES: 'files',
};
